import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import fastDeepEqual from "fast-deep-equal/react.js";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { useBoolean } from "usehooks-ts";
import Input from "../../../input/index.js";
import Inputs from "../../../../others/inputs/index.js";
import { nullFunction } from "../../../../../../helpers/null.js";
import useFormatInputDate from "../../hooks/useFormatDate.js";
import CalendarMobileModal from "./components/modal/index.js";
import * as S from "./styled.js";
const CalendarMobileSingle = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { value , label , disabled =false , error , hasError , onClick , onBlur , isVisible =false , enableTime =false  } = props;
    const inputRef = useRef(null);
    useImperativeHandle(ref, ()=>inputRef.current);
    const inputValue = useFormatInputDate(value[0], enableTime, inputRef);
    return /*#__PURE__*/ _jsx(S.CalendarMobileInputWrapper, {
        "data-testid": "CalendarMobileInputWrapper",
        onClick: onClick,
        children: /*#__PURE__*/ _jsx(Input, {
            type: "button",
            label: label,
            value: inputValue,
            onChange: nullFunction,
            disabled: disabled,
            error: error,
            hasError: hasError,
            ref: inputRef,
            onBlur: onBlur,
            isFocused: isVisible
        })
    });
});
CalendarMobileSingle.displayName = 'CalendarMobileSingle';
const CalendarMobileRange = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { value =[
        new Date(),
        new Date()
    ] , startDateLabel , endDateLabel , disabled =false , enableTime =false , error , hasError , onClick , onBlur , isVisible =false  } = props;
    const startInputRef = useRef(null);
    useImperativeHandle(ref, ()=>startInputRef.current);
    const endInputRef = useRef(null);
    useImperativeHandle(ref, ()=>endInputRef.current);
    const startInputValue = useFormatInputDate(value[0], enableTime, startInputRef);
    const endInputValue = useFormatInputDate(value[1], enableTime, endInputRef);
    return /*#__PURE__*/ _jsxs(Inputs, {
        children: [
            /*#__PURE__*/ _jsx(S.CalendarMobileInputWrapper, {
                "data-testid": "CalendarMobileInputWrapper",
                onClick: onClick,
                className: "calendar-range-input",
                children: /*#__PURE__*/ _jsx(Input, {
                    type: "button",
                    label: startDateLabel,
                    value: startInputValue,
                    onChange: nullFunction,
                    disabled: disabled,
                    error: error,
                    hasError: hasError,
                    ref: startInputRef,
                    onBlur: onBlur,
                    isFocused: isVisible
                })
            }),
            /*#__PURE__*/ _jsx(S.CalendarMobileInputWrapper, {
                onClick: onClick,
                className: "calendar-range-input",
                children: /*#__PURE__*/ _jsx(Input, {
                    type: "button",
                    label: endDateLabel,
                    value: endInputValue,
                    onChange: nullFunction,
                    disabled: disabled,
                    hasError: hasError,
                    ref: endInputRef,
                    onBlur: onBlur
                })
            })
        ]
    });
});
CalendarMobileRange.displayName = 'CalendarMobileRange';
const CalendarMobile = /*#__PURE__*/ forwardRef((props, ref)=>{
    const isSingle = props.mode === 'single';
    const { className ='' , ...calendarProps } = props;
    const [tempValue, setTempValue] = useState(props.value);
    const { value: isVisible , toggle: toggleVisibility  } = useBoolean();
    const showModal = ()=>{
        if (props.disabled) return;
        setTempValue(props.value);
        toggleVisibility();
    };
    const cancel = ()=>{
        if (!fastDeepEqual(tempValue, props.value)) {
            props.onChange?.(tempValue);
        }
        toggleVisibility();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-testid": "Calendar",
                className: className,
                children: isSingle ? /*#__PURE__*/ _jsx(CalendarMobileSingle, {
                    ...props,
                    onClick: showModal,
                    ref: ref,
                    isVisible: isVisible
                }) : /*#__PURE__*/ _jsx(CalendarMobileRange, {
                    ...props,
                    onClick: showModal,
                    ref: ref,
                    isVisible: isVisible
                })
            }),
            isVisible && /*#__PURE__*/ _jsx(CalendarMobileModal, {
                visible: isVisible,
                confirm: toggleVisibility,
                cancel: cancel,
                ...calendarProps
            })
        ]
    });
});
CalendarMobile.displayName = 'CalendarMobile';
export default CalendarMobile;

//# sourceMappingURL=index.js.map